<template>
  <div class="sm-auth__template-form">
    <h3 class="sm-txt-center">Log in</h3>
    <form class="sm-auth__main-form" @submit.prevent="handleSubmit">
      <input-text
        v-model="login"
        :value="login"
        :label="'Username or Email'"
        :name="'login'"
        v-validate="`required`"
        data-vv-as="username"
        :error="errors.first('login')"
        @blur="validateInput"
      />
      <input-text
        v-model="password"
        :value="password"
        :label="'Password'"
        :name="'password'"
        :type="'password'"
        v-validate="`required|min:6`"
        :error="errors.first('password')"
      />
      <span
        v-if="errors.first('back_errors')"
        class="sm-small sm-error sm-auth__main-form-error"
      >{{errors.first('back_errors')}}</span>
      <btn-block :text="'Log in'" type="submit" />
    </form>
    <a class="sm-google-auth-btn" :href="googleAuthLink"><include-svg :name="'icon-google'" /> Log in with Google</a>
    <router-link :to="{ name: 'reset-password' }" class="sm-link sm-link-blue">Forgot password?</router-link>
    <sm-spinner :show="showSpinner"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import InputText from "@/components/InputText";
import Spinner from "@/components/Spinner.vue"
export default {
  name: "login",
  components: {
    "input-text": InputText,
    "sm-spinner": Spinner,
  },
  data() {
    return {
      login: "",
      password: "",
      submitted: false,
      showSpinner: false,
    };
  },
  created() {
    this.showSpinner = true;
    if(this.$route.query && this.$route.query.first_sso === 'true' && this.$route.query.refresh_token) {
      localStorage.setItem('token', this.$route.query.refresh_token);
      this.$router.push('/sign-up?first_sso=true');
    }
    else if(this.$route.query && this.$route.query.refresh_token) {
      localStorage.setItem('token', this.$route.query.refresh_token);
      this.setIsAdmin(false);
      this.$router.push('/');
    } else {
      this.showSpinner= false;
      this.Logout();
      this.setIsAdmin(false);
    }
  },
  computed: {
    ...mapGetters({
      isDev: 'isDev'
    }),
    googleAuthLink() {
      return this.isDev ? 'https://staging-api.spheremail.co/auth/google' : 'https://api.spheremail.co/auth/google' 
    }
  },
  methods: {
    ...mapActions({
      Login: "auth/login",
      Logout: "auth/logout",
      setIsAdmin: "setIsAdmin"
    }),
    handleSubmit(e) {
      this.submitted = true;
      const { login, password } = this;
      this.errors.remove("back_errors");
      
      this.$validator.validate().then(valid => {
        if (!valid) return false;

        const redirect_url = (() => { // works only for customers, change condition in login fun to make it work for admin
          if(this.$route.query && this.$route.query.redirect_to && this.$route.query.redirect_to === 'form1583')
            return "/customer/account?notarize=1"
          return '/'
        })();

        this.Login({ login, password, redirect_url})
          .then()
          .catch(err => {
            const error = err.response;

            if (error.status === 500) {
              this.errors.add({
                field: "back_errors",
                msg: error.data.error
              });
            } else {
              const messages = error.data.errors;

              Object.keys(messages).forEach(key => {
                this.errors.add({
                  field: "back_errors",
                  msg: messages[key][0]
                });
              });
            }
          });
      });
    },
    validateInput() {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (re.test(String(this.login))) // check if input is email
        this.login = this.login.toLowerCase();
    }
  },
  watch: {
    // TEMP
    login: {
      handler() {
        this.errors.remove("back_errors");
      },
      deep: true
    },
    password: {
      handler() {
        this.errors.remove("back_errors");
      },
      deep: true
    },
  }
};
</script>
